.ah{flex-shrink:0;}